import { useApi } from 'services';

export const useCalculateSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation`,
    'POST',
    {},
    {},
    true
);

export const useRecalculateSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation`,
    'PUT',
    {},
    {}
);

export const useCalculateCancellationSync = (idOperation) => useApi(
    `v2/operation/${idOperation}/premium-calculation-cancellation`,
    'POST',
    {},
    {},
    true
);

export const useComissionRate = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation/comission`,
    'GET',
    {},
    {}
);